/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, TextField, Link } from '@material-ui/core';
import MaterialTable from 'material-table';
import useDashboard from '../../../../hooks/useDashboard';
import useQuickBook from '../../../../hooks/useQuickBook';
import usePractice from '../../../../hooks/usePractice';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover'; /* eslint-disable-next-line */
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
/* Modal */
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import useStyles from '../../Main.style';
import SummaryInvoiceByCell from '../SummaryInvoiceByCell/SummaryInvoiceByCell';
import { Autocomplete } from '@material-ui/lab';
import {
  customSortHelper,
  formatToCurrency,
  formatToNumber,
  getLoggedInUserData,
} from '../../../../utils/Helper';

const MyPersonalPerformance = React.memo(function MyPersonalPerformance() {
  /* Modal */
  const loggedInUserData = getLoggedInUserData();
  const { getDashboardComments } = usePractice();
  const defaultState = 'changeInStatus';
  const { getTotalPastDueInvoicesForAllCells, getProfitRevenue } = useQuickBook();
  const {
    getFileManagementMyCellTable,
    getMyCellInvoicingPerformance,
    getMyInvoicingPerformance,
    getMyLogiwareDetails,
    getMyPersonalPerformancePerChangeStatus,
    getFileManagementMyCellTablePerChangeStatus,
  } = useDashboard();
  const [summaryInvoiceByCellArr, setSummaryInvoiceByCellArr] = React.useState([]);
  const [personalFileManagementLoader, setPersonalFileManagementLoader] = useState(false);
  const [cellFileManagementLoader, setCellFileManagementLoader] = useState(false);
  const [myInvoicingPerformanceData, setMyInvoicingPerformanceData] = useState([]);
  const [fileManagementByCellList, setFileManagementByCellList] = useState([]);
  const [myCellInvoicingPerformanceData, setMyCellInvoicingPerformanceData] = useState([]);
  const [profitRevenueQbObjByCell, setProfitRevenueQbObjByCell] = React.useState([]);
  const [myLogiwareData, setMyLogiwareData] = useState([]);
  const [dashboardComments, setDashboardComments] = useState([]);
  const [statusToFetchMyPersonalPerformance, setStatusToFetchMyPersonalPerformance] = useState(
    defaultState,
  );
  const [statusToFetchMyCellPerformance, setStatusToFetchMyCellPerformance] = useState(
    defaultState,
  );
  const [shouldShowComponent, setShouldShowComponent] = useState(true);
  const loadPastDueInvoicesByCell = async () => {
    const pastDueInvoicesArr = await getTotalPastDueInvoicesForAllCells();
    setSummaryInvoiceByCellArr(pastDueInvoicesArr?.reportResult || []);
  };
  async function findParentObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = await findParentObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = await findParentObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  const loadMyInvoicingPerformance = async () => {
    const myInvoicingPerformance = await getMyInvoicingPerformance({
      userName: loggedInUserData?.userName,
      userId: loggedInUserData?.id,
      countryTitle: loggedInUserData?.country?.countryValue,
    });
    setMyInvoicingPerformanceData(myInvoicingPerformance?.usersResult);
  };

  //My Personal Performance File Management Table
  const loadMyPersonalPerformanceFileManagementTable = async (
    statusToFetchMyPersonalPerformance,
  ) => {
    setPersonalFileManagementLoader(true);
    const myLogiwareDetails =
      statusToFetchMyPersonalPerformance == 'actualStatus'
        ? await getMyLogiwareDetails({
            userName: loggedInUserData?.userName,
            countryTitle: loggedInUserData?.country?.countryValue,
          })
        : await getMyPersonalPerformancePerChangeStatus({
            userName: loggedInUserData?.userName,
            countryTitle: loggedInUserData?.country?.countryValue,
          });
    setMyLogiwareData(myLogiwareDetails?.usersResult);
    setPersonalFileManagementLoader(false);
  };
  const loadProfitQb = async () => {
    let revenueValueByCell = 0;
    let revenuePrevYearValueByCell = 0;
    let profitValueByCell = 0;
    let profitPrevYearValueByCell = 0;

    const resultDataByCell = await getProfitRevenue({
      cellId: loggedInUserData?.cell?.qbId ? loggedInUserData?.cell?.qbId : null,
    });

    if (resultDataByCell) {
      revenueValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Total Income',
      );
      revenuePrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Total Income',
      );
      profitValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultYtd,
        'Net Income',
      );

      profitPrevYearValueByCell = await findParentObjectBySearchText(
        resultDataByCell?.reportResultPrevYear,
        'Net Income',
      );

      setProfitRevenueQbObjByCell(
        loggedInUserData?.cell?.qbId
          ? {
              revenueValueByCell: revenueValueByCell?.parent[1]?.value,
              revenuePrevYearValueByCell: revenuePrevYearValueByCell?.parent[1]?.value,
              profitValueByCell: profitValueByCell?.parent[1]?.value,
              profitPrevYearValueByCell: profitPrevYearValueByCell?.parent[1]?.value,
            }
          : [],
      );
    }
  };

  const loadDashboardCommentsDetails = async () => {
    const result = await getDashboardComments();
    if (result) {
      setDashboardComments(result?.usersResult);
    }
  };
  const loadManagementMyCellList = async (statusToFetchMyCellPerformance) => {
    setCellFileManagementLoader(true);
    const managementMyCellList =
      statusToFetchMyCellPerformance == 'actualStatus'
        ? await getFileManagementMyCellTable({
            cellValue: loggedInUserData?.cell?.cellValue,
            countryTitle: loggedInUserData?.country?.countryValue,
          })
        : await getFileManagementMyCellTablePerChangeStatus({
            cellValue: loggedInUserData?.cell?.cellValue,
            countryTitle: loggedInUserData?.country?.countryValue,
          });
    setFileManagementByCellList(managementMyCellList?.usersResult);
    setCellFileManagementLoader(false);
  };

  const loadMyCellInvoicingPerformance = async () => {
    const myCellInvoicingPerformance = await getMyCellInvoicingPerformance({
      cellValue: loggedInUserData?.cell?.cellValue,
      countryTitle: loggedInUserData?.country?.countryValue,
      cellId: loggedInUserData?.cellId,
      countryId: loggedInUserData?.countryId,
    });
    setMyCellInvoicingPerformanceData(myCellInvoicingPerformance?.usersResult || []);
  };

  useEffect(() => {
    loadDashboardCommentsDetails(); /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    const condition = true;
    setShouldShowComponent(condition);
  }, []);
  useEffect(() => {
    loadManagementMyCellList(statusToFetchMyCellPerformance);
  }, []);

  useEffect(() => {
    loadMyPersonalPerformanceFileManagementTable(statusToFetchMyPersonalPerformance);
  }, []);

  useEffect(() => {
    loadPastDueInvoicesByCell();
  }, []);

  useEffect(() => {
    loadMyCellInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadMyInvoicingPerformance();
  }, []);

  useEffect(() => {
    loadProfitQb();
  }, []);

  const typeOptions = [
    { id: 'actualStatus', title: 'Actual Status' },
    { id: 'changeInStatus', title: 'Change in Status' },
  ];

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Personal Performance:{' '}
                    {loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        Invoicing
                      </Typography>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Personal Performance"
                      />
                    </Box>
                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        isLoading={myInvoicingPerformanceData?.length === 0 ? true : false}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'metrix',
                            sorting: false,
                            // customSort: (a, b) => customSortHelper(a, b, 'metrix'),
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Personal Performance"
                              />
                            ),
                          },
                          {
                            title: new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            customSort: (a, b) => customSortHelper(a, b, 'ytd'),
                            render: (data) =>
                              data?.type == null
                                ? formatToCurrency(
                                    data?.ytd,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToNumber(data?.ytd, classes, data?.type),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            customSort: (a, b) => customSortHelper(a, b, 'vectorRank'),
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myInvoicingPerformanceData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Employee',
                            field: 'bestcell',
                            customSort: (a, b) => customSortHelper(a, b, 'bestCell'),

                            render: (data) =>
                              data?.type == null
                                ? formatToCurrency(
                                    data?.bestCell,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToNumber(data?.bestCell, classes, data?.type),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            // customSort: (a, b) => a.prevYear.localeCompare(b.prevYear),
                            customSort: (a, b) => customSortHelper(a, b, 'prevYear'),
                            render: (data) =>
                              data?.type == null
                                ? formatToCurrency(
                                    data?.prevYear,
                                    classes,
                                    data?.subType ? data?.subType : '',
                                  )
                                : formatToNumber(data?.prevYear, classes, data?.type),
                          },
                        ]}
                        data={myInvoicingPerformanceData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                    >
                      <Box mb={{ xs: 2, sm: 0 }}>
                        <Typography variant="h5" noWrap>
                          File Management
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: 200,
                          border: '1px solid #003C6F',
                          borderRadius: '4px',
                          marginTop: '-8px',
                        }}
                        mb={{ xs: 1, sm: 0 }}
                      >
                        <Autocomplete
                          id="type"
                          options={typeOptions}
                          disablePortal
                          getOptionLabel={(option) => option?.title}
                          getOptionSelected={(option, value) => option?.id === value?.id}
                          value={
                            statusToFetchMyPersonalPerformance
                              ? typeOptions.find(
                                  (d) => d?.id === statusToFetchMyPersonalPerformance,
                                )
                              : null
                          }
                          onChange={(e, value) => {
                            setStatusToFetchMyPersonalPerformance(
                              value?.id ? value?.id : defaultState,
                            );
                            loadMyPersonalPerformanceFileManagementTable(
                              value?.id ? value?.id : defaultState,
                            );
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Type" name="type" variant="outlined" />
                          )}
                          popupIcon={<ExpandMoreIcon />}
                        />
                      </Box>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Personal Performance File Management"
                      />
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        isLoading={personalFileManagementLoader}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: loggedInUserData?.firstName + ' ' + loggedInUserData?.lastName,
                            field: 'cellf',
                            sorting: false,
                            //customSort: (a, b) => customSortHelper(a, b, 'metrix'),
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Personal Performance File Management columns"
                              />
                            ),
                          },

                          {
                            title:
                              statusToFetchMyPersonalPerformance == 'actualStatus'
                                ? 'Today'
                                : new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            render: (data) => formatToNumber(data?.ytd, classes),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorRank',

                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...myLogiwareData.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },

                          {
                            title: 'Top Employee',
                            customSort: (a, b) => customSortHelper(a, b, 'bestCell'),
                            field: 'bestcell',
                            render: (data) => formatToNumber(data?.bestCell, classes),
                          },
                          {
                            title: 'Last Year',
                            field: 'prevYear',
                            render: (data) => formatToNumber(data?.prevYear),
                            hidden:
                              statusToFetchMyPersonalPerformance == 'actualStatus' ? true : false,
                          },
                        ]}
                        data={myLogiwareData || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Link color="textPrimary" href="/#/app/dashboard/my-performance">
                      <Typography variant="caption">View all</Typography>
                    </Link>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">
                    My Cell's Performance: {'Cell ' + loggedInUserData?.cell?.cellTitle}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        Invoicing
                      </Typography>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText={"My Cell's Performance"}
                      />
                    </Box>

                    <SummaryInvoiceByCell
                      reportArr={summaryInvoiceByCellArr}
                      myCellInvoiceArray={myCellInvoicingPerformanceData}
                      myProfitRevenue={profitRevenueQbObjByCell}
                      dashboardComments={dashboardComments}
                      dashboardSectionText={"My Cell's Performance"}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite} height="100%">
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                    >
                      <Box mb={{ xs: 2, sm: 0 }}>
                        <Typography variant="h5" noWrap>
                          File Management
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: 200,
                          border: '1px solid #003C6F',
                          borderRadius: '4px',
                          marginTop: '-8px',
                        }}
                        mb={{ xs: 1, sm: 0 }}
                      >
                        <Autocomplete
                          id="type"
                          options={typeOptions}
                          disablePortal
                          getOptionLabel={(option) => option?.title}
                          getOptionSelected={(option, value) => option?.id === value?.id}
                          value={
                            statusToFetchMyCellPerformance
                              ? typeOptions.find((d) => d?.id === statusToFetchMyCellPerformance)
                              : null
                          }
                          onChange={(e, value) => {
                            setStatusToFetchMyCellPerformance(value?.id ? value?.id : defaultState);
                            loadManagementMyCellList(value?.id ? value?.id : defaultState);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Type" name="type" variant="outlined" />
                          )}
                          popupIcon={<ExpandMoreIcon />}
                        />
                      </Box>
                      <InfoPopover
                        dashboardComments={dashboardComments}
                        dashboardSectionText="My Cell's Performance File Management"
                      />
                    </Box>

                    <Box mt={1} className={classes.TableUIV2}>
                      <MaterialTable
                        style={{ boxShadow: 'none' }}
                        isLoading={cellFileManagementLoader}
                        options={{
                          toolbar: false,
                          draggable: false,
                          paging: false,
                          sorting: true,
                          pageSize: 20,
                          pageSizeOptions: [10, 20, 50, 100],
                          showTextRowsSelected: false,
                          toolbarButtonAlignment: 'right',
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -100,
                          emptyRowsWhenPaging: false,
                        }}
                        localization={{
                          pagination: {
                            labelRowsSelect: 'Rows',
                            labelRowsPerPage: 'Rows Per Page',
                          },
                        }}
                        title="File Management"
                        columns={[
                          {
                            title: 'Cell ' + loggedInUserData?.cell?.cellTitle,
                            field: 'cellf',
                            sorting: false,
                            render: (data) => (
                              <InfoPopoverCommentsWrapper
                                dashboardComments={dashboardComments}
                                section={data?.metrix}
                                title="My Cell's Performance File Management columns"
                              />
                            ),
                          },
                          {
                            title:
                              statusToFetchMyCellPerformance == 'actualStatus'
                                ? 'Today'
                                : new Date().getFullYear() + ' YTD',
                            field: 'ytd',
                            customSort: (a, b) => customSortHelper(a, b, 'ytd'),
                            render: (data) => formatToNumber(data?.ytd, classes),
                          },
                          {
                            title: 'Ranking',
                            field: 'vectorranking',
                            customSort: (a, b) => customSortHelper(a, b, 'vectorRank'),
                            render: (data) => (
                              <span
                                className={
                                  data?.vectorRank ==
                                  Math.max(...fileManagementByCellList.map((o) => o?.vectorRank))
                                    ? classes.vectorRankingRed
                                    : data?.vectorRank == 1
                                    ? classes.vectorRankingGreen
                                    : classes.vectorranking
                                }
                              >
                                {data?.vectorRank}
                              </span>
                            ),
                          },
                          {
                            title: 'Top Cell',
                            field: 'bestcell',
                            customSort: (a, b) => customSortHelper(a, b, 'bestCell'),
                            render: (data) => formatToNumber(data?.bestCell, classes),
                          },
                          {
                            title: 'Last Year',
                            field: 'previousyear',
                            hidden: statusToFetchMyCellPerformance == 'actualStatus' ? true : false,
                            customSort: (a, b) => customSortHelper(a, b, 'prevYear'),
                            render: (data) => formatToNumber(data?.prevYear, classes),
                          },
                        ]}
                        data={fileManagementByCellList || []}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="flex-end"
                height={1}
                mt={0.5}
              >
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                  <Box>
                    <Link color="textPrimary" href="/#/app/dashboard/my-cell">
                      <Typography variant="caption">View all</Typography>
                    </Link>
                  </Box>
                  <Box className={classes.ViewAll}>
                    <ArrowForwardIcon />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
});

export default MyPersonalPerformance;
